<template>
    <path
        d="M16.3505 7.07988C17.4295 5.68881 17.1764 3.68645 15.7854 2.6075C14.3943 1.52855 12.3919 1.78157 11.313 3.17264C10.234 4.56372 10.4871 6.56607 11.8781 7.64502C13.2692 8.72398 15.2716 8.47095 16.3505 7.07988Z"
        stroke-width="1.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M7.67578 16.7891C7.67578 13.3932 10.4362 10.6328 13.832 10.6328C17.2279 10.6328 19.9883 13.3932 19.9883 16.7891"
        stroke-width="1.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M7.43966 7.14133C8.02125 6.05621 7.61306 4.70507 6.52794 4.12348C5.44281 3.54189 4.09168 3.95009 3.51009 5.03521C2.9285 6.12033 3.3367 7.47147 4.42182 8.05306C5.50694 8.63465 6.85808 8.22645 7.43966 7.14133Z"
        stroke-width="1.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M1.17578 14.2357C1.17578 11.8607 3.10286 9.93359 5.47787 9.93359C7.23828 9.93359 8.7487 10.9857 9.41537 12.5065"
        stroke-width="1.2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</template>
